import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../components/Input/Index";
import { enableDisableProposalAction } from "../../store/actions/proposalActions";
import { uploadBulkDisable } from "../../store/actions/fileUploadActions"
import DataTable from "../../components/Table";
import { ButtonGroup } from "react-bootstrap";
import {ToggleButton} from "react-bootstrap";
import { toaster } from "../../utils/utils";
const EnableDisableProposal = () => {
    const [proposalNumber, setProposalNumber] = useState("");
    const [radioValue, setRadioValue] = useState('ENABLE');
    const [enableDisableData, setEnableDisableData] = useState("")
    const dispatch = useDispatch();
    const triggerUploadCSV = () => {
        document.getElementById("csv-upload").click();
    };
    const radios = [
        { name: 'ENABLE', value: '1' },
        { name: 'DISABLE', value: '2' },
    ];
    const enableDisableProposal = useCallback(() => {
        let disable= radioValue==="ENABLE"? false:true;
        console.log("klkl22", disable, radioValue)
        dispatch(enableDisableProposalAction(proposalNumber,disable, (data) => {
            const { body } = data
            if (body) {
                const disable = [body]
                setEnableDisableData(disable)
            }
        }));
    }, [proposalNumber, dispatch]);

    const disableAllProposal = (file) => {
        let formData = new FormData();
        formData.append("file", file);
        {radioValue==="ENABLE"?formData.append("disableProposal", false):formData.append("disableProposal", true)}
        console.log("checking file", formData)
        dispatch(uploadBulkDisable(formData, (data) => {
            console.log("upload file", data);
            const { data: { body } } = data
            if (body) {
                setEnableDisableData(body)
            }
        }));
    }
    const onRadioChange=(value)=>{
        setRadioValue(value)
        setProposalNumber("")
    }
    return (
        <>
            <div className="proposalDetails_comp">
                    <>
                    <div className="tabSelection">
                    {radios.map((radio, idx) => (
                    <ButtonGroup key={idx} className="mb-2 tab-buttons">
                        <ToggleButton
                            key={idx}
                            id={`radio-${idx}`}
                            type="radio"
                            variant="primary"
                            name="radio"
                            value={radio.name}
                            checked={radioValue === radio.name}
                            // onChange={(e) => setRadioValue(e.currentTarget.value)}
                            onChange={(e) => onRadioChange(e.currentTarget.value)}
                        >
                            {radio.name}
                        </ToggleButton>

                    </ButtonGroup>
                ))}
                    </div>
                       
                    
                < button className="searchbt searchbt_disable" onClick={triggerUploadCSV}>
                Upload All
            </button>
            </>
            <input
                style={{
                    visibility: "hidden",
                    width: "0px",
                    height: "0px",
                }}
                id="csv-upload"
                className="file-input"
                type="file"
                name="file"
                accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onChange={(e) => {
                    if(e.target.files && e.target.files.length && e.target.files[0].size / 1000 / 1000 > 10){
                        return toaster("warn", "Selected file size cannot be greater than 10 mb.")
                    }
                  else if(e.target.files && e.target.files.length) {
                        disableAllProposal(e.target.files[0]);
                    }
                }}
                onClick={(e)=> { 
                    e.target.value = null
               }}
            />
            <Input
                name="proposalNumber"
                value={proposalNumber}
                onChange={(name, value) => setProposalNumber(value)}
                placeholder="Enter Proposal Number"
            />
            <button className="searchbt" onClick={enableDisableProposal}>
                Submit
            </button>
            {enableDisableData && (
                <DataTable
                    cellHeaders={["Proposal Number", "Remarks", "Enabled/Disabled Status"]}
                    data={enableDisableData}
                    keys={["proposalNumber", "remarks", "disbaledStatus"]}
                    fileName="enable/disble"
                    addSerialNo={true}
                    showExcelDownload={true}
                    PerPageApiData={false}
                    paginationItems={enableDisableData}
                    alwaysShown={false}
                    convertValueToString={true}
                />
            )}
        </div >
        </>
        
    );
};

export default EnableDisableProposal;
